module.exports = __webpack_public_path__ + "static/img/各種ご注文.3aa0ae8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/domain1/各種ご注文.png
// module id = t9dS
// module chunks = 0